import { useNavigate } from 'react-router-dom'
import { useLanguage } from '../hooks/useLanguage'
import { useAuth } from '../context/AuthContext'
import ProtectedRoute from './ProtectedRoute'

function Paywall({ diasRestantes }) {
  const { t } = useLanguage()
  const navigate = useNavigate()

  return (
    <div style={{ minHeight: '100vh', background: 'var(--color-bg)', display: 'flex', flexDirection: 'column' }}>
      <header style={{ background: 'var(--color-surface)', borderBottom: '1px solid var(--color-border)', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 12, position: 'sticky', top: 0, zIndex: 10 }}>
        <button
          onClick={() => navigate('/home')}
          style={{ width: 36, height: 36, background: 'rgba(120,120,120,0.08)', border: '1px solid var(--color-border)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: 18, color: 'var(--color-text)', transition: '0.2s' }}
          onMouseEnter={e => { e.currentTarget.style.transform = 'translateX(-2px)'; e.currentTarget.style.borderColor = 'var(--color-primary)' }}
          onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.borderColor = 'var(--color-border)' }}
        >←</button>
        <div>
          <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--color-text)' }}>{t(' volver')}</div>
        </div>
      </header>

      <main style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
        <div style={{ maxWidth: 380, width: '100%', textAlign: 'center', background: 'var(--color-surface)', border: '1px solid var(--color-border)', borderRadius: 24, padding: '36px 26px', boxShadow: 'var(--shadow-card)' }}>
          <div style={{ width: 64, height: 64, borderRadius: 18, margin: '0 auto 18px', background: 'linear-gradient(135deg,var(--stat-saving-1),var(--stat-saving-2))', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 30 }}>🔒</div>
          <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--color-text)', marginBottom: 8 }}>
            {diasRestantes > 0 ? t('paywall_trial_titulo') : t('paywall_vencido_titulo')}
          </div>
          <div style={{ fontSize: 13, color: 'var(--color-muted)', lineHeight: 1.6, marginBottom: 24 }}>
            {diasRestantes > 0
              ? `${t('paywall_trial_desc_pre')} ${diasRestantes} ${diasRestantes === 1 ? t('paywall_dia') : t('paywall_dias')}. ${t('paywall_trial_desc_post')}`
              : t('paywall_vencido_desc')}
          </div>
          <button
            onClick={() => navigate('/suscripcion')}
            style={{ width: '100%', padding: '14px', borderRadius: 16, border: 'none', background: 'linear-gradient(135deg,#16a34a,#22c55e)', color: 'white', fontWeight: 700, fontSize: 15, cursor: 'pointer', boxShadow: 'var(--shadow-btn)' }}
          >
            {t('paywall_btn')}
          </button>
        </div>
      </main>
    </div>
  )
}

function PremiumGate({ children }) {
  const { hasAccess, diasRestantes } = useAuth()
  if (!hasAccess) return <Paywall diasRestantes={diasRestantes} />
  return children
}

export default function PremiumRoute({ children }) {
  return (
    <ProtectedRoute>
      <PremiumGate>{children}</PremiumGate>
    </ProtectedRoute>
  )
}